import { getLogmarLineSize500mm } from './functions';
import { calibrationConstants } from './calibration-constants';
import { useTestContext } from '../context/testContext';
import { useCalibration } from '../context/calibrationContext';
import { useCallback } from 'react';

export const useLogmarSizeCalculations = () => {
  const { pixelDensityReference, patientDistanceReference } = calibrationConstants;
  const { testData } = useTestContext();
  const {
    calibrationData: { pixelDensity },
  } = useCalibration();

  const getFontSize = useCallback(
    (logmar, distance) => {
      const lineSize = getLogmarLineSize500mm(logmar);
      const fontSize = (lineSize * distance) / patientDistanceReference / pixelDensity;
      const fontSizeAdjustment = (pixelDensity * testData.fontAdjustmentPercentage) / pixelDensityReference / 100;
      const adjustedFontSize = fontSize + fontSize * fontSizeAdjustment;
      return adjustedFontSize;
    },
    [patientDistanceReference, pixelDensity, pixelDensityReference, testData.fontAdjustmentPercentage],
  );

  const getContentSize = useCallback(
    (logmar, distance) => {
      const lineSize = getLogmarLineSize500mm(logmar);
      const contentSize = (lineSize * distance) / patientDistanceReference / pixelDensity;
      return contentSize;
    },
    [patientDistanceReference, pixelDensity],
  );

  return { getFontSize, getContentSize };
};
